var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.135742,
    width: 0,
    height: 0,
    stroke: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6361 27.7087C14.2819 27.7087 8.30273 27.417 5.82357 26.8337C4.80273 26.542 4.07357 25.8128 3.7819 24.792C3.3444 23.1878 3.05273 19.8337 3.05273 17.5003C3.05273 15.167 3.3444 11.8128 3.7819 10.2087C4.07357 9.18783 4.80273 8.45866 5.82357 8.16699C8.30273 7.58366 14.2819 7.29199 17.6361 7.29199C20.9902 7.29199 26.9694 7.58366 29.4486 8.16699C30.4694 8.45866 31.1986 9.18783 31.4902 10.2087C31.9277 11.8128 32.2194 15.167 32.2194 17.5003C32.2194 19.8337 31.9277 23.1878 31.4902 24.792C31.1986 25.8128 30.4694 26.542 29.4486 26.8337C26.9694 27.417 20.9902 27.7087 17.6361 27.7087Z",
    stroke: "currentColor",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7188 21.875L22.0104 17.5L14.7188 13.125V21.875Z",
    stroke: "currentColor",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.dbb1caf03661a7c4c98e6581b3fff66c.svg";
export { ForwardRef as ReactComponent };